"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _componentsWeb = require("@telus-uds/components-web");
var _ShortAnswerField = _interopRequireDefault(require("../ShortAnswerField"));
var _LongAnswerField = _interopRequireDefault(require("../LongAnswerField"));
var _NumberField = _interopRequireDefault(require("../NumberField"));
var _EmailField = _interopRequireDefault(require("../EmailField"));
var _DropdownListField = _interopRequireDefault(require("../DropdownListField"));
var _RadioButtonField = _interopRequireDefault(require("../RadioButtonField"));
var _CheckboxField = _interopRequireDefault(require("../CheckboxField"));
var _PhoneNumberField = _interopRequireDefault(require("../PhoneNumberField"));
var _PostalCodeField = _interopRequireDefault(require("../PostalCodeField"));
var _ConditionalField = _interopRequireDefault(require("../ConditionalField"));
var _HiddenField = _interopRequireDefault(require("../HiddenField"));
var _AddressField = _interopRequireDefault(require("../AddressField"));
var _DatePickerField = _interopRequireDefault(require("../DatePickerField"));
var _RichText = _interopRequireDefault(require("../RichText"));
var _GenesysTimeSlotsField = _interopRequireDefault(require("../GenesysTimeSlotsField"));
var _utils = require("../utils");
var _ConsentField = _interopRequireDefault(require("../ConsentField"));
var _FileUploadField = _interopRequireDefault(require("../FileUploadField"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var calculateIsConditionalField = isConditionalFieldFlag => isConditionalFieldFlag ? true : false;
var renderField = (field, fieldValues, preFillValues, language, clickedSubmit, inputRef, fieldData, fieldReferences, isProduction, environment) => {
  var isConditionalField = calculateIsConditionalField(field === null || field === void 0 ? void 0 : field.isConditionalField);
  var fieldComponent;
  switch (field.type) {
    case 'formBuilderRichText':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_RichText.default, field);
      break;
    case 'shortAnswerField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_ShortAnswerField.default, {
        key: field.id,
        label: field.label,
        onChange: field.onChange,
        value: fieldValues[field.id] || preFillValues[field.fieldName],
        hint: field.hint,
        hintPosition: field.hintPosition,
        placeholder: field.placeholder,
        minlength: field.minLength,
        maxlength: field.maxLength,
        isRequired: field.isRequired,
        language: language,
        clickedSubmit: clickedSubmit,
        inputRef: inputRef,
        customErrorMessage: field.customErrorMessage,
        isReadOnly: field.isReadOnly || false
      });
      break;
    case 'longAnswerField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_LongAnswerField.default, {
        key: field.id,
        label: field.label,
        onChange: field.onChange,
        value: fieldValues[field.id] || preFillValues[field.fieldName],
        hint: field.hint,
        placeholder: field.placeholder,
        minlength: field.minLength,
        maxlength: field.maxLength,
        isRequired: field.isRequired,
        language: language,
        clickedSubmit: clickedSubmit,
        inputRef: inputRef,
        customErrorMessage: field.customErrorMessage,
        isReadOnly: field.isReadOnly || false
      });
      break;
    case 'numberField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_NumberField.default, {
        key: field.id,
        label: field.label,
        onChange: field.onChange,
        value: fieldValues[field.id] || preFillValues[field.fieldName],
        hint: field.hint,
        hintPosition: field.hintPosition,
        placeholder: field.placeholder,
        minValue: field.minValue,
        maxValue: field.maxValue,
        isRequired: field.isRequired,
        language: language,
        clickedSubmit: clickedSubmit,
        inputRef: inputRef,
        customErrorMessage: field.customErrorMessage,
        isReadOnly: field.isReadOnly || false
      });
      break;
    case 'emailField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_EmailField.default, {
        key: field.id,
        label: field.label,
        onChange: field.onChange,
        value: fieldValues[field.id] || preFillValues[field.fieldName],
        hint: field.hint,
        hintPosition: field.hintPosition,
        placeholder: field.placeholder,
        requireConfirm: field.requireConfirmation,
        maxlength: field.maxLength,
        isRequired: field.isRequired,
        language: language,
        clickedSubmit: clickedSubmit,
        inputRef: inputRef,
        customErrorMessage: field.customErrorMessage,
        isReadOnly: field.isReadOnly || false,
        confirmEmailLabel: field.confirmEmailLabel
      });
      break;
    case 'dropdownListField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DropdownListField.default, {
        key: field.id,
        label: field.label,
        hint: field.hint,
        options: field.options,
        onChange: field.onChange,
        value: fieldValues[field.id] || preFillValues[field.fieldName],
        isRequired: field.isRequired,
        language: language,
        clickedSubmit: clickedSubmit,
        inputRef: inputRef,
        customErrorMessage: field.customErrorMessage,
        isReadOnly: field.isReadOnly || false
      }), isConditionalField && /*#__PURE__*/_react.default.createElement(_ConditionalField.default, {
        key: "conditional-field-".concat(field.id),
        conditionalFieldControllerValues: fieldValues[field.id],
        field: field,
        fieldData: fieldData,
        fieldReferences: fieldReferences,
        fieldValues: fieldValues,
        clickedSubmit: clickedSubmit,
        language: language
      }));
      break;
    case 'radioButtonField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_RadioButtonField.default, {
        key: field.id,
        label: field.label,
        fieldName: field.fieldName,
        hint: field.hint,
        hintPosition: field.hintPosition,
        hintOnTop: field.hintOnTop,
        options: field.options,
        onChange: field.onChange,
        value: fieldValues[field.id],
        isRequired: field.isRequired,
        language: language,
        clickedSubmit: clickedSubmit,
        inputRef: inputRef,
        customErrorMessage: field.customErrorMessage,
        isReadOnly: field.isReadOnly || false
      }), isConditionalField && /*#__PURE__*/_react.default.createElement(_ConditionalField.default, {
        key: "conditional-field-".concat(field.id),
        conditionalFieldControllerValues: fieldValues[field.id],
        field: field,
        fieldData: fieldData,
        fieldReferences: fieldReferences,
        fieldValues: fieldValues,
        clickedSubmit: clickedSubmit,
        language: language
      }));
      break;
    case 'checkboxField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_CheckboxField.default, {
        key: field.id,
        label: field.label,
        fieldName: field.fieldName,
        hint: field.hint,
        hintPosition: field.hintPosition,
        hintOnTop: field.hintOnTop,
        errorMessage: field.errorMessage,
        options: field.options,
        twoColumnsOnDesktop: field.twoColumnsOnDesktop,
        onChange: field.onChange,
        value: fieldValues[field.id] || [preFillValues[field.fieldName]],
        minSelected: field.minSelected,
        maxSelected: field.maxSelected,
        isRequired: field.isRequired,
        language: language,
        clickedSubmit: clickedSubmit,
        inputRef: inputRef,
        isReadOnly: field.isReadOnly || false
      }), isConditionalField && /*#__PURE__*/_react.default.createElement(_ConditionalField.default, {
        key: "conditional-field-".concat(field.id),
        conditionalFieldControllerValues: fieldValues[field.id],
        field: field,
        fieldData: fieldData,
        fieldReferences: fieldReferences,
        fieldValues: fieldValues,
        clickedSubmit: clickedSubmit,
        language: language
      }));
      break;
    case 'phoneNumberField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_PhoneNumberField.default, _extends({}, field, {
        key: field.id,
        label: field.label,
        onChange: field.onChange,
        value: fieldValues[field.id] || preFillValues[field.fieldName],
        hint: field.hint,
        hintPosition: field.hintPosition,
        placeholder: field.placeholder,
        isRequired: field.isRequired,
        language: language,
        clickedSubmit: clickedSubmit,
        inputRef: inputRef,
        customErrorMessage: field.customErrorMessage,
        isReadOnly: field.isReadOnly || false
      }));
      break;
    case 'postalCodeField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_PostalCodeField.default, {
        key: field.id,
        label: field.label,
        onChange: field.onChange,
        value: fieldValues[field.id] || preFillValues[field.fieldName],
        hint: field.hint,
        hintPosition: field.hintPosition,
        placeholder: field.placeholder,
        isRequired: field.isRequired,
        language: language,
        clickedSubmit: clickedSubmit,
        inputRef: inputRef,
        customErrorMessage: field.customErrorMessage,
        isReadOnly: field.isReadOnly || false
      });
      break;
    case 'hiddenField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_HiddenField.default, {
        key: field.id,
        value: preFillValues[field.fieldName],
        onChange: field.onChange,
        isRequired: field.isRequired,
        inputRef: inputRef
      });
      break;
    case 'addressField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_AddressField.default, {
        key: field.id,
        label: field.label,
        onChange: field.onChange,
        value: fieldValues[field.id] || preFillValues[field.fieldName],
        hint: field.hint,
        placeholder: field.placeholder,
        isRequired: field.isRequired,
        language: language,
        clickedSubmit: clickedSubmit,
        inputRef: inputRef,
        customErrorMessage: field.customErrorMessage,
        isLPDSIDRequired: field.isLPDSIDRequired || false,
        isProduction: isProduction,
        environment: environment,
        showUnitNumber: field.showUnitNumber,
        unitNumberHint: field.unitNumberHint,
        unitNumberPlaceholder: field.unitNumberPlaceholder,
        unitNumberLabel: field.unitNumberLabel,
        unitNumberMaxLength: field.unitNumberMaxLength,
        unitNumberCustomErrorMessage: field.unitNumberCustomErrorMessage,
        isPrefill: field.isPrefill || false,
        isReadOnly: field.isReadOnly || false,
        addressQuerySource: field.addressQuerySource
      });
      break;
    case 'datePickerField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_DatePickerField.default, {
        key: field.id,
        hint: field.hint,
        tooltip: field.tooltip,
        hintPosition: field.hintPosition,
        label: field.label,
        isRequired: field.isRequired,
        language: language,
        clickedSubmit: clickedSubmit,
        value: fieldValues[field.id] || preFillValues[field.fieldName],
        onChange: field.onChange,
        inputRef: inputRef,
        isReadOnly: field.isReadOnly || false,
        offset: field.offset,
        variant: field.variant
      });
      break;
    case 'consentField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_ConsentField.default, {
        key: field.id,
        legalTemplate: field.legalTemplate,
        options: field.consentOptions,
        language: language,
        onChange: field.onChange,
        clickedSubmit: clickedSubmit,
        inputRef: inputRef,
        errorMessage: field.customErrorMessage,
        isReadOnly: field.isReadOnly || false
      });
      break;
    case 'genesysTimeSlotsField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_GenesysTimeSlotsField.default, {
        key: field.id,
        label: field.label,
        hint: field.hint,
        selectLabel: field.selectLabel,
        datepickerLegend: field.datepickerLegend,
        customErrorMessageSelect: field.customErrorMessageSelect,
        customErrorMessageButton: field.customErrorMessageButton,
        hintPosition: field.hintPosition,
        placeholder: field.placeholder,
        language: language,
        clickedSubmit: clickedSubmit,
        customErrorMessage: field.customErrorMessage,
        dataAdapter: field.dataAdapter,
        fieldValues: fieldValues,
        fieldReferences: fieldReferences,
        environment: environment,
        fieldData: fieldData,
        value: fieldValues[field.id] || preFillValues[field.fieldName],
        onChange: field.onChange,
        brand: field.brand,
        subBrand: field.subBrand,
        displayDays: field.displayDays,
        productType: field.productType,
        customerIntent: field.customerIntent,
        businessDomain: field.businessDomain
      });
      break;
    case 'fileUploadField':
      fieldComponent = /*#__PURE__*/_react.default.createElement(_FileUploadField.default, {
        key: field.id,
        language: language,
        isRequired: field.isRequired,
        inputRef: inputRef,
        onChange: field.onChange,
        maxFilesCount: field.maxFilesCount,
        minFilesCount: field.minFilesCount,
        maxFileSize: field.maxFileSize,
        minFileSize: field.minFileSize,
        allowedFileTypes: field.allowedFileTypes,
        clickedSubmit: clickedSubmit
      });
      break;
    default:
      return undefined;
  }
  return /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid.Col, {
    key: "field-".concat(field.id),
    xs: (0, _utils.fieldWidthsToFlexGridSizes)(field.mobileWidth),
    md: (0, _utils.fieldWidthsToFlexGridSizes)(field.tabletWidth),
    lg: (0, _utils.fieldWidthsToFlexGridSizes)(field.desktopWidth)
  }, fieldComponent);
};
var renderFieldComponent = {
  renderField
};
var _default = exports.default = renderFieldComponent;